<template>
  <pagefra>
    <div class="faultReport container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('工号')">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('处理状态')">
              <el-select v-model="form.status" :placeholder="$l('处理状态')">
                <el-option :label="$l('处理状态')" value="-1"></el-option>
                <el-option :label="$l('待处理')" value="0"></el-option>
                <el-option :label="$l('已处理')" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              icon="el-icon-edit-outline"
              type="primary"
              round
              @click="handleFault"
              v-show="hasPermission('处理')"
              >{{ $l("处理") }}
            </el-button>
            <el-button
              icon="el-icon-delete"
              round
              @click="deleteFaultReport"
              v-show="hasPermission('删除')"
              >{{ $l("删除") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" min-width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('工号')"
              prop="jobNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('客户名称')"
              prop="customerName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('详细地址')"
              prop="address"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('保障联系人')"
              prop="reporter"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('手机号码')"
              prop="telNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('困人数量')"
              prop="num"
              align="center"
              min-width="100"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('处理状态')"
              prop="status"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0">{{ $l("未处理") }} </span>
                <span v-else>{{ $l("已处理") }} </span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('上报人')"
              prop="creator"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('上报时间')"
              prop="createDate"
              align="center"
              min-width="200"
              sortable
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import global from "@/mixins/global.js";
export default {
  name: "faultReport",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        jobNum: "",
        status: "-1",
      },
      tableData: [],
      selectedList: [],
      loading: false,
    };
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      let dataListCacheKey = this.$options.name + "_data_list";
      let dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_fault_report_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    handleFault() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要处理的数据");
        return;
      }
      this.confirmAlert(() => {
        let idList = [];
        for (let i = 0; i < len; i++) {
          idList.push(this.selectedList[i].faultId);
        }
        let formData = new FormData();
        formData.append("idList", idList);
        this.$http
          .post(this.$apiConfig.update_fault_report_status_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(this.messageType.operate);
            this.$sentry.captureException(error);
          });
      }, "你确定要做此操作吗?");
    },
    deleteFaultReport() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要删除的数据");
        return;
      }
      this.confirmAlert(() => {
        let idList = [];
        for (let i = 0; i < len; i++) {
          idList.push(this.selectedList[i].faultId);
        }
        let formData = new FormData();
        formData.append("idList", idList);
        this.$http
          .post(this.$apiConfig.delete_fault_report_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(this.messageType.delete);
            this.$sentry.captureException(error);
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.faultReport {
  em {
    color: red;
  }
}
</style>
